import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./reduxHooks";
import { GET } from "../service/api";
import { triggerToastMessage } from "../utils/utils";
import { ApiUrl } from "../utils/constants/ApiUrl";

const TWO_HOURS_IN_MS = 2 * 60 * 60 * 1000;

export const useManufacturingFileTypes = () => {
  const dispatch = useAppDispatch();

  // Select data and timestamp from Redux
  const { testDataFileTypes, testDataFileTypesFetchedAt, testDataFileTypesLoading } = useAppSelector(
    (state) => state.CustomerDetailsReducer // Adjust 'state.customer' to match your root reducer key
  );

  useEffect(() => {
    const now = Date.now();
    const isDataEmpty = testDataFileTypes === null ? true : false;

    // Check if data is expired (older than 2 hours)
    // If fetchedAt is null, it's considered expired/missing
    const isExpired = testDataFileTypesFetchedAt
      ? now - testDataFileTypesFetchedAt > TWO_HOURS_IN_MS
      : true;

    // Dispatch ONLY if missing or expired
    if (isDataEmpty || isExpired) {
      console.log(
        "Data missing or expired. Fetching manufacturing-file-types..."
      );
      dispatch(
        GET("customers/manufacturing-file-types", ApiUrl.testDataFileTypes)()
      ).then((response: any) => {
        if (response?.error) {
          triggerToastMessage(
            "Error fetching manufacturing file types.",
            "error"
          );
        }
      });
    }
  }, [dispatch, testDataFileTypes, testDataFileTypesFetchedAt]);

  return {testDataFileTypes, testDataFileTypesLoading};
};
